import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'my-maps',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'my-maps',
    loadComponent: () => import('./my-maps/my-maps.component').then(m => m.MyMapsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'create-map',
    loadComponent: () => import('./create-map/create-map.component').then(m => m.CreateMapComponent),
    canActivate: [authGuard]
  },
  {
    path: 'appcheck-init',
    loadComponent: () => import('@shared').then(m => m.AppCheckInitComponent),
    data: { siteKey: environment.appCheck?.siteKey, defaultHref: '/my-maps' }
  },
  {
    path: '**',
    loadComponent: () => import('@shared').then(m => m.NotFoundComponent),
    data: { toolbarColor: 'faded-green', homeRoute: '/my-maps' }
  }
];

